// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.benchmark-video-dialog__subtitle {
  display: block;
  margin-top: 4px;
  font-size: 13px;
  font-weight: 500;
  opacity: 0.75;
}

.benchmark-video-dialog__center {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 24px 8px;
  text-align: center;
}

.benchmark-video-dialog__calib {
  background: rgba(10, 132, 255, 0.08);
  border: 1px solid rgba(10, 132, 255, 0.22);
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 12px;
  font-size: 13px;
}

.benchmark-video-dialog__calib ul {
  margin: 8px 0 0;
  padding-left: 18px;
}

.benchmark-video-dialog__hint {
  font-size: 14px;
  line-height: 1.45;
  opacity: 0.85;
}

.benchmark-video-dialog__error {
  margin: 12px 0;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(255, 69, 58, 0.12);
  border: 1px solid rgba(255, 69, 58, 0.35);
  color: #ff453a;
  font-size: 13px;
}

.benchmark-video-dialog__table-wrap {
  overflow-x: auto;
  margin-top: 8px;
  border-radius: 10px;
  border: 1px solid rgba(128, 128, 128, 0.25);
}

.benchmark-video-dialog__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
}

.benchmark-video-dialog__table th,
.benchmark-video-dialog__table td {
  padding: 8px 10px;
  text-align: left;
  border-bottom: 1px solid rgba(128, 128, 128, 0.18);
  white-space: nowrap;
}

.benchmark-video-dialog__table th {
  font-weight: 650;
  background: rgba(128, 128, 128, 0.08);
  vertical-align: top;
}

.benchmark-video-dialog__pill {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 6px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.benchmark-video-dialog__pill--complete,
.benchmark-video-dialog__pill--ready {
  background: rgba(52, 199, 89, 0.18);
  color: #248a3d;
}

.benchmark-video-dialog__pill--running,
.benchmark-video-dialog__pill--queued,
.benchmark-video-dialog__pill--processing {
  background: rgba(10, 132, 255, 0.16);
  color: #0a84ff;
}

.benchmark-video-dialog__pill--planned {
  background: rgba(128, 128, 128, 0.16);
  color: #8e8e93;
}

.benchmark-video-dialog__pill--failed {
  background: rgba(255, 69, 58, 0.16);
  color: #ff453a;
}

.benchmark-video-dialog__pill--partial {
  background: rgba(255, 159, 10, 0.18);
  color: #c93400;
}

.benchmark-video-dialog__warn {
  display: block;
  margin-top: 8px;
  font-size: 12px;
  color: #c93400;
}

.benchmark-video-dialog__col-err {
  margin-top: 4px;
  font-size: 10px;
  font-weight: 500;
  color: #ff453a;
  white-space: normal;
  max-width: 140px;
}
`, "",{"version":3,"sources":["webpack://./src/components/BenchmarkVideoDialog.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;;EAGE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":[".benchmark-video-dialog__subtitle {\n  display: block;\n  margin-top: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  opacity: 0.75;\n}\n\n.benchmark-video-dialog__center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 24px 8px;\n  text-align: center;\n}\n\n.benchmark-video-dialog__calib {\n  background: rgba(10, 132, 255, 0.08);\n  border: 1px solid rgba(10, 132, 255, 0.22);\n  border-radius: 10px;\n  padding: 12px 14px;\n  margin-bottom: 12px;\n  font-size: 13px;\n}\n\n.benchmark-video-dialog__calib ul {\n  margin: 8px 0 0;\n  padding-left: 18px;\n}\n\n.benchmark-video-dialog__hint {\n  font-size: 14px;\n  line-height: 1.45;\n  opacity: 0.85;\n}\n\n.benchmark-video-dialog__error {\n  margin: 12px 0;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: rgba(255, 69, 58, 0.12);\n  border: 1px solid rgba(255, 69, 58, 0.35);\n  color: #ff453a;\n  font-size: 13px;\n}\n\n.benchmark-video-dialog__table-wrap {\n  overflow-x: auto;\n  margin-top: 8px;\n  border-radius: 10px;\n  border: 1px solid rgba(128, 128, 128, 0.25);\n}\n\n.benchmark-video-dialog__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12.5px;\n}\n\n.benchmark-video-dialog__table th,\n.benchmark-video-dialog__table td {\n  padding: 8px 10px;\n  text-align: left;\n  border-bottom: 1px solid rgba(128, 128, 128, 0.18);\n  white-space: nowrap;\n}\n\n.benchmark-video-dialog__table th {\n  font-weight: 650;\n  background: rgba(128, 128, 128, 0.08);\n  vertical-align: top;\n}\n\n.benchmark-video-dialog__pill {\n  display: inline-block;\n  margin-left: 6px;\n  padding: 1px 6px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.benchmark-video-dialog__pill--complete,\n.benchmark-video-dialog__pill--ready {\n  background: rgba(52, 199, 89, 0.18);\n  color: #248a3d;\n}\n\n.benchmark-video-dialog__pill--running,\n.benchmark-video-dialog__pill--queued,\n.benchmark-video-dialog__pill--processing {\n  background: rgba(10, 132, 255, 0.16);\n  color: #0a84ff;\n}\n\n.benchmark-video-dialog__pill--planned {\n  background: rgba(128, 128, 128, 0.16);\n  color: #8e8e93;\n}\n\n.benchmark-video-dialog__pill--failed {\n  background: rgba(255, 69, 58, 0.16);\n  color: #ff453a;\n}\n\n.benchmark-video-dialog__pill--partial {\n  background: rgba(255, 159, 10, 0.18);\n  color: #c93400;\n}\n\n.benchmark-video-dialog__warn {\n  display: block;\n  margin-top: 8px;\n  font-size: 12px;\n  color: #c93400;\n}\n\n.benchmark-video-dialog__col-err {\n  margin-top: 4px;\n  font-size: 10px;\n  font-weight: 500;\n  color: #ff453a;\n  white-space: normal;\n  max-width: 140px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
